import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthenticationService } from '@hunter/authentication';
import { UserInformation } from '@hunter-service-libraries/user-service';
import { localAppConfig } from 'src/app/app-config';


@Component({

  selector: 'app-profile-icon',
  templateUrl: './profile-icon.component.html',
  styleUrls: ['./profile-icon.component.scss'],
  standalone: false
})
export class ProfileIconComponent implements OnChanges, OnInit{
  @Input() currentUser: UserInformation;
  isSpoofing = false;
  profileIconImage: string;
  constructor(
    private readonly router: Router,
    public dialog: MatDialog,
    private readonly authenticationService: AuthenticationService,
  ) {}

  ngOnInit() {
    this.isSpoofing =  this.authenticationService.isSpoofing();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.currentUser = changes.currentUser.currentValue;
    this.profileIconImage = this.buildProfileIconImage();
  }

  buildProfileIconImage() {
    if (this.currentUser.UserId != null && this.currentUser.UserId !== '') {
      return `${localAppConfig.BaseUrl}/UserService/api/Users/${this.currentUser.UserId}/Image?api-version=2.0`;
    }
    return '';
  }

  signoutLink() {
    this.router.navigate(['/signout'], { queryParams: [],  replaceUrl: true  }); // replaceUrl true prevents user from going back in history
  }

}
